import { createElementVNode as _createElementVNode, openBlock as _openBlock, createElementBlock as _createElementBlock } from "vue"

const _hoisted_1 = {
  xmlns: "http://www.w3.org/2000/svg",
  fill: "none",
  viewBox: "0 0 24 24"
}

export function render(_ctx, _cache) {
  return (_openBlock(), _createElementBlock("svg", _hoisted_1, [...(_cache[0] || (_cache[0] = [
    _createElementVNode("path", {
      fill: "currentColor",
      "fill-rule": "evenodd",
      d: "M8.404 1.617C8.8 1.222 9.335 1 9.894 1h4.212a2.106 2.106 0 0 1 2.107 2.106v1.639h6.085a.702.702 0 0 1 0 1.404h-2.132l-1.128 14.873a2.3 2.3 0 0 1-.46 1.202c-.366.462-.947.772-1.76.772H6.9c-.338.02-.848-.027-1.31-.351-.506-.353-.833-.95-.896-1.791-.053-.703-.277-3.488-.532-6.653-.223-2.775-.47-5.84-.646-8.052H1.702a.702.702 0 0 1 0-1.404h6.085V3.106c0-.558.222-1.094.617-1.489m6.405 1.49v1.638H9.19V3.106a.7.7 0 0 1 .703-.702h4.212a.7.7 0 0 1 .703.702m-4.213 7.255a.702.702 0 1 0-1.405 0v7.021a.702.702 0 1 0 1.405 0zm3.51-.702c.388 0 .703.314.703.702v7.021a.702.702 0 1 1-1.405 0v-7.021c0-.388.315-.702.702-.702m-8.545 4.417c-.22-2.72-.46-5.717-.635-7.91h13.83L17.64 20.9a.9.9 0 0 1-.164.453c-.077.097-.238.239-.659.239h-9.94q-.026 0-.05.002a.7.7 0 0 1-.433-.1c-.09-.062-.261-.23-.3-.745-.053-.705-.278-3.5-.533-6.672",
      "clip-rule": "evenodd"
    }, null, -1)
  ]))]))
}
export default { render: render }